import React from 'react';
import OfferPageListServerPaginated from '@/components/OfferPageListServerPaginated';
import { useItemActions } from '@/hooks/useItemActions';
import { Card, CardContent } from '@/components/ui/card';
import { OnboardingBlocker } from '@/components/onboarding';

interface BundlesTabProps {
  filterStatus?: string;
  searchQuery?: string;
  onEdit?: (id: string) => void;
}

const BundlesTab: React.FC<BundlesTabProps> = ({ 
  filterStatus = 'active',
  searchQuery = '',
  onEdit
}) => {
  const { handleCopyLink, handleArchive } = useItemActions();
  
  return (
    <OnboardingBlocker requireStripe={true} requireBusinessProfile={true}>
      <Card className="border shadow-sm">
        <CardContent className="p-0">
          <OfferPageListServerPaginated 
            filterStatus={filterStatus}
            searchQuery={searchQuery}
            onCopyLink={(id) => handleCopyLink(id, 'bundle')}
            onArchive={(id) => handleArchive(id, 'offer')}
            onEdit={onEdit}
          />
        </CardContent>
      </Card>
    </OnboardingBlocker>
  );
};

export default BundlesTab;
